import Api from './Api'

export default {
    registrarListaEspera(idEvento){
        return Api().post(`listaEspera/register`, { idEvento } );
    },
    getMyList(){
        return Api().get(`listaEspera/getMylist`);
    }
}